import React, {useEffect, useState} from 'react';
import {useAuth} from "../../providers/AuthProvider";
import {Navigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Logout = (props) => {
    const { t} = useTranslation();

    const authContext = useAuth();
    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        document.title = t('Logout')+' | LocalBoost';
        authContext.logout();

        setUnauthorized(true);
    }, []);

    return (
        <>
            <div className="text-center">
                <h4 className="mb-0">{t('Thank you!')}</h4>
            </div>

            {unauthorized && (
                <Navigate to="/auth/login" replace={true} />
            )}
        </>
    );
}

export default Logout;
